/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { B200, N600, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
// @ts-ignore - issue in monorepo with internal module resolution https://product-fabric.atlassian.net/browse/AFP-1822
import { CustomItem } from '@atlaskit/menu';
import LockIcon from '@atlaskit/icon/glyph/lock';

import { Link } from 'gatsby';
import type { LinkGetProps } from '@reach/router';

export interface NavItemProps {
  text: string;
  slug?: string;
  type?: 'heading';
  href?: string;
  to: string;
  isSelected?: boolean;
  isLocked?: boolean;
  isPrivate?: boolean;
  isSubItem?: boolean;
  isPartiallyActive?: (props: LinkGetProps) => any;
  parent?: string | undefined | null;
}

// NB - I don't want to use `cssFn` and this is the least bad way
// to get specificity to win.
const navLinkStyles = css({
  '&&': {
    color: token('color.text', N600),
    minHeight: 32,
    paddingLeft: 32,
  },
});

const subItemPaddingStyles = css({
  '&&': {
    paddingLeft: 48,
  },
});

const selectedStyle = css({
  boxShadow: `inset 4px 0px 0px ${token('color.border.selected', B200)}`,
});

const NavItem = ({
  text,
  href,
  to,
  isSelected = false,
  isSubItem,
  isLocked = false,
  isPartiallyActive,
}: NavItemProps) => {
  return (
    <CustomItem
      isSelected={isSelected}
      component={({
        wrapperClass,
        children,
        ...rest
      }: {
        wrapperClass: string;
        children: React.ReactNode;
      }) => {
        return (
          <Link
            getProps={isPartiallyActive}
            className={wrapperClass}
            to={href || to}
            {...rest}
            css={[
              navLinkStyles,
              isSubItem && subItemPaddingStyles,
              isSelected && selectedStyle,
            ]}
          >
            {children}
            {isLocked && (
              <LockIcon
                label="private-icon"
                primaryColor={token('color.text.disabled', N90)}
              />
            )}
          </Link>
        );
      }}
    >
      {text}
    </CustomItem>
  );
};

export default NavItem;
